export const SITE = {
  name: "USA Limo Service",
  tagline: "Luxury Transportation Since 1984",
  phones: {
    office: "202-779-6054",
    virginia: "703-979-6664",
    dispatch: "202-232-4440",
  },
  // Tel-format (E.164-ish for tel: links)
  phonesTel: {
    office: "+12027796054",
    virginia: "+17039796664",
    dispatch: "+12022324440",
  },
  primaryPhone: "703-979-6664",
  email: "info@usalimoservice.com",
  address: "Washington DC · Virginia · Maryland",

  // Logos
  logo: "https://customer-assets.emergentagent.com/job_7dfa33ae-00df-4dc4-a172-5c24b284029f/artifacts/xti2dp7p_USALIMO-1920w.webp",
  zuberLogo: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/56a58q3r_9962EFC6-72B2-4523-A216-585F7F1C1345.PNG",

  // Hero & DC — high-res Unsplash sources (w=2400, q=80)
  heroFleet: "https://images.unsplash.com/photo-1764004657175-11ce991efcca?fm=jpg&q=80&w=2400&auto=format&fit=crop", // US Capitol night light trails
  heroMixed: "https://images.unsplash.com/photo-1565970695389-c1d00f478e17?fm=jpg&q=80&w=2400&auto=format&fit=crop", // Lincoln Memorial long exposure at night
  heroSUV: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/6xoi8gwg_suv1.webp", // Black Cadillac Escalade close-up
  heroCapitol: "https://images.unsplash.com/photo-1543372654-b45dd90eeee5?fm=jpg&q=80&w=2400&auto=format&fit=crop", // US Capitol Hill at night
  heroMonument: "https://images.unsplash.com/photo-1770956473373-7ef6942fda8c?fm=jpg&q=80&w=2400&auto=format&fit=crop", // Washington Monument at dusk
  jefferson: "https://images.unsplash.com/photo-1770956473373-7ef6942fda8c?fm=jpg&q=80&w=2400&auto=format&fit=crop",
  dcBridge: "https://images.unsplash.com/photo-1543372654-b45dd90eeee5?fm=jpg&q=80&w=2400&auto=format&fit=crop",

  // Fleet imagery
  sedanMercedes: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/ddk03vg9_1-e536cb6c-463084c9-1920w.webp",
  suvLineup: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/copwirmm_1-62500bc1.jpg",
  vanFord: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/ffxbnf4i_12.png",
  sprinterBlack: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/28a167cz_6-1920w.webp",
  coachExecutive: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/5vxm0fyx_10-1920w.webp",
  motorCoach: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/tniyoa2l_7-10818926.png",
  suvInterior: "https://customer-assets.emergentagent.com/job_executive-limo-dc/artifacts/un6ih5dj_2.webp",
};

export const VEHICLE_OPTIONS = [
  "Cadillac XTS",
  "Mercedes Benz S Class",
  "Cadillac Escalade",
  "Sprinter Van",
  "Chevrolet Suburban",
  "Expedition",
  "GMC Yukon",
  "Lincoln Navigator",
  "Other",
];

export const SERVICE_AREAS = [
  "Washington DC", "Arlington VA", "Alexandria VA", "McLean VA", "Fairfax VA",
  "Tysons VA", "Bethesda MD", "Rockville MD", "Silver Spring MD",
  "Northern Virginia", "Maryland", "Nationwide",
];

export const KEYWORDS = [
  "limo service Washington DC",
  "luxury transportation DMV",
  "chauffeur service DC",
  "airport transportation Washington DC",
  "black car service Virginia",
  "executive transportation DMV",
  "luxury car service Maryland",
  "corporate transportation DC",
  "wedding limo service DMV",
  "chauffeur for hire DC",
  "valet parking service DMV",
];
